import { render } from "./OtpInput.vue?vue&type=template&id=35e69126&ts=true"
import script from "./OtpInput.vue?vue&type=script&lang=ts"
export * from "./OtpInput.vue?vue&type=script&lang=ts"

import "./OtpInput.vue?vue&type=style&index=0&id=35e69126&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/OtpInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35e69126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35e69126', __exports__)) {
    api.reload('35e69126', __exports__)
  }
  
  module.hot.accept("./OtpInput.vue?vue&type=template&id=35e69126&ts=true", () => {
    api.rerender('35e69126', render)
  })

}


export default __exports__